module.exports = __webpack_public_path__ + "assets/img/4.e661714d.png";